import { create } from 'zustand';
import { WaitingCallStoreType } from '../types/store/waiting-call.types';

export const useWaitingCallStore = create<WaitingCallStoreType>((set) => ({
  waitingCall: null,
  isSilenced: false,
  isRejectWithOpen: false,
  setWaitingCall: (waitingCall) => set({ waitingCall }),
  setIsSilenced: (isSilenced) => set({ isSilenced }),
  setIsRejectWithOpen: (isRejectWithOpen) => set({ isRejectWithOpen }),
  resetWaitingCall: () => set({ waitingCall: null, isSilenced: false, isRejectWithOpen: false }),
}));
